// extracted by mini-css-extract-plugin
export default {"cancelButton":"PunchupCompedTicketsTable_cancelButton__ZoiGA"};